import React,{ useEffect, useState,useImperativeHandle,forwardRef } from 'react';
import styles from '../styles.scss';
import Error from '@/components/Error';
import { history } from 'umi';
import { getCourseDirectory,getDirectoryDetail,courseConvert } from '@/services/course';
import {Toast} from 'antd-mobile';
import ConvertDialog from './ConvertDialog';
import { getUserInfo } from '@/services/myself';
import { setLoginUser } from '@/utils/login';

export default forwardRef((props,ref) => {

  const {course, playDir} = props;

  const [dirList, setDirList] = useState([]);
  const [error, setError] = useState(null);

  const [selectDir, setSelectDir] = useState(null);

  const [convertDir, setConvertDir] = useState(null);
// 关键代码
  useImperativeHandle(ref, () => ({
    defaultPlay: () => {
      if (dirList.length > 0) {
        let dir = dirList[0];
        if (dir.isPlay == '0') {
          setConvertDir(dir);

        } else {
          dirClick(dir);
        }
      }
    }
  }));

  useEffect(()=>{
    getDir();
  },[]);

  function getDir() {
    getCourseDirectory({courseId:course.id,pageNo:1,pageSize:1000}).then(res => {
      console.log(res);

      if (res && res.code == 200) {
        setDirList(res.data.list);
        setError(null);
      }else {
        setError('目录加载失败，请重试');
      }
    }).catch(e => {
      setError('目录加载失败，请重试');
    });
  }


  return(
    <div className={styles.tabBox} style={{overflow:'scroll'}}>

      <label className={styles.dirLabel}>目录</label>
      {error && <Error error={error} onRefresh={() =>{
        getDir();
      }}/>}

      {!error && dirList.map(item => (
        <div className={styles.dirItem} key={item.id} onClick={() => {
          if (item.isPlay == '0') {
            setConvertDir(item);

          } else {
            dirClick(item);
          }
        }}>

          <label className={selectDir && selectDir.id ==  item.id ? styles.dirName_on : styles.dirName}>
            {item.hourName + '  ' + item.directoryName}
          </label>

          {getButton(item)}
        </div>
      )) }


      <ConvertDialog isShow={convertDir !== null} dir={convertDir}
                     closeCallback={()=>{
                       setConvertDir(null)
                     }}
                     confirmClick={()=>{
                       setConvertDir(null)
                       convert();
                     }}/>



    </div>
  )


  function getButton(item) {
    if (item.type == '1') {
      return (
        <div className={styles.button_free}>免费</div>
      )
    } else if (item.type == '2') {
      return (
        <div className={styles.button_exchange}>{getButtonText(item.isPlay)}</div>
      )
    }else if (item.type == '3') {
      return(
        <div className={styles.button_free}>会员免费</div>
      )
    } else {
      return;
    }
  }

  function getButtonText(isPlay) {
    if (isPlay == '1') {
      return '已兑换';
    }else if (isPlay == '2') {
      return '限免';
    } else {
      return '兑换';
    }
  }




  function dirClick(dir) {
    Toast.loading('loading',60);
    getDirectoryDetail({id:dir.id}).then(res => {
      Toast.hide();
      console.log(res);
      if (res.code == 200) {
        setSelectDir(res.data);
        playDir && playDir(res.data);
      }else{
        Toast.fail(res.message,1);
      }
    }).catch(e => {
      console.log(e);
      Toast.hide();
      Toast.fail('获取失败，请重试',1);
    })
  }




  function convert() {
    Toast.loading('正在兑换...',60);
    courseConvert({directoryId:convertDir.id}).then(res => {
      Toast.hide();
      console.log(res);
      if (res.code == 200) {
          getUserInfo().then(res => {
            if (res && res.code == 200) {
              setLoginUser(res.data);
            }
          });
        getDir();
        setSelectDir(convertDir);
      }else {
        Toast.fail(res.message,1);
      }
    }).catch(e => {
      Toast.hide();
      Toast.fail('兑换失败，请重试',1);
    })
  }


})
